/* eslint-disable */
export default {
  inAMeeting: '開會中',
  onMyWay: '在路上',
  callMeBackIn: '請於以下時間過後回電…',
  willCallYouBackIn: '將於以下時間過後回電…',
  hour: '小時',
  min: '分鐘',
} as const;

// @key: @#@"inAMeeting"@#@ @source: @#@"In a meeting"@#@
// @key: @#@"onMyWay"@#@ @source: @#@"On my way"@#@
// @key: @#@"callMeBackIn"@#@ @source: @#@"Call me back in..."@#@
// @key: @#@"willCallYouBackIn"@#@ @source: @#@"Will call you back in..."@#@
// @key: @#@"hour"@#@ @source: @#@"hour"@#@
// @key: @#@"min"@#@ @source: @#@"min"@#@
